/**
 * @generated SignedSource<<05fc920db0e87a51ae18a385b7ca785c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PiecePlayBody_piece$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListenPlayer_Piece" | "SimplifiedNoteByNotePlayer_Piece" | "OnSheetNoteByNotePlayer_Piece" | "Export_Piece">;
  readonly " $fragmentType": "PiecePlayBody_piece";
};
export type PiecePlayBody_piece$key = {
  readonly " $data"?: PiecePlayBody_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PiecePlayBody_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PiecePlayBody_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListenPlayer_Piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimplifiedNoteByNotePlayer_Piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OnSheetNoteByNotePlayer_Piece"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Export_Piece"
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "4d1c710c1f6d0ab11bef89f671350524";

export default node;
